import { render, staticRenderFns } from "./starrating.vue?vue&type=template&id=4864dafd&"
import script from "./starrating.vue?vue&type=script&lang=js&"
export * from "./starrating.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4864dafd')) {
      api.createRecord('4864dafd', component.options)
    } else {
      api.reload('4864dafd', component.options)
    }
    module.hot.accept("./starrating.vue?vue&type=template&id=4864dafd&", function () {
      api.rerender('4864dafd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2IAVyz2XvJ3DO/JS/comp/starrating.vue"
export default component.exports